import type { ReactNode } from 'react';
import { Card, InfoTip, SectionLabel, cn } from '@wundo/ui';
import { InfoText } from './InfoText.tsx';

export interface ChartCardProps {
  title: string;
  /** The sentence behind the figure, as the body of an info bubble. */
  info?: string;
  /** The reading itself, top right — a latest value, a rate, a legend. */
  aside?: ReactNode;
  /** One quiet line under the title: what the chart counts. */
  description?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** The box every chart on the metrics history page sits in. */
export function ChartCard({
  title,
  info,
  aside,
  description,
  className,
  children,
}: ChartCardProps) {
  return (
    <Card as='section' className={cn('flex flex-col gap-4', className)}>
      {/* On a phone the aside goes under the title: side by side the title gets one word a line. */}
      <div className='flex items-start justify-between gap-3 max-mobile:flex-col'>
        <div className='min-w-0'>
          <div className='flex items-center gap-1'>
            <SectionLabel as='h2'>{title}</SectionLabel>
            {info !== undefined && (
              <InfoTip content={<InfoText text={info} />} label={title} />
            )}
          </div>
          {description !== undefined && (
            <p className='mt-1 text-xs text-ink-muted'>{description}</p>
          )}
        </div>
        {aside !== undefined && (
          <div className='shrink-0 text-right max-mobile:text-left'>{aside}</div>
        )}
      </div>
      {children}
    </Card>
  );
}
